<script lang="ts">
  import {translate} from "$lib/i18n";
</script>
<div class="flex justify-center items-center flex-col m-2 text-white">
  <div class="flex justify-center items-center border-b border-b-primary-lightBlue mb-4 pb-2 w-full ">
    <span class="text-white text-xl">{$translate('Forza Spring Gallop Tournament')}</span>
  </div>
  <div class="flex flex-col text-sm text-primary-lightBlue">
    <ul class="list-disc ml-5 space-y-2">
    <li>{$translate('Earn points by placing bets on Live Casino games and Slots - every $100 wagered equals 1 point!')}</li>
    <li>{$translate('The tournament\'s start and end dates are clearly displayed. Once it concludes, your winnings will be credited automatically, and you’ll receive a notification.')}</li>
    <li>{$translate('To maintain fairness, duplicate accounts or fraudulent activity may result in account suspension. ForzaBet guarantees that the tournament rules remain unchanged, ensuring a fair competition for all participants. Rest assured, every prize listed is within your reach!')}</li>
    </ul>
  </div>
</div>
